import { csx } from '@vtex/admin-ui'

const styles = {
  full: csx({
    width: '100%',
  }),
  label: csx({ marginRight: '$space-6', color: 'inherit' }),
  icon: csx({
    '&&': {
      marginRight: 0,
      marginLeft: 'auto',
    },
  }),
}

export default styles
